/* ==========================================================================
   Furrly — buy box.
   Vanilla, no dependencies, no build step. Loaded with `defer` after
   furrly.js, so it settles the buy-box state last.

   This file formats nothing. Every price string it writes was rendered by
   Liquid in sections/furrly-product.liquid and handed over in
   window.FURRLY.buyBox — which is why a JS-written price can never disagree
   with a server-written one, and why there is no blank price on first paint.

   Division of labour with furrly.js:
     furrly.js  — gallery + swipe, info accordion, review figures, and the
                  add-to-cart itself (it intercepts the form's submit event,
                  posts to /cart/add.js and opens the drawer).
     this file  — which cat count is selected, which words and prices are
                  showing, the hidden form inputs, and the sticky bar.
   The sticky bar's button deliberately does NOT carry furrly.js's
   `data-bar-cta`; it submits the form instead, so there is exactly one
   add-to-cart path.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = (window.FURRLY || {}).buyBox;
  if (!CFG || !CFG.packs) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };

  var root = $('.fb');
  var form = $('[data-atc-form]');
  if (!root) return;

  var tiles = $$('[data-bb-cat]', root);
  if (!tiles.length) return;

  var TILES = tiles.length;                                  // 4 shown
  var MAX = Math.max(TILES, Object.keys(CFG.packs).length);  // 12 reachable
  var lastTile = tiles[TILES - 1];

  /* --- State ---------------------------------------------------------------
     Two things and no more: how many cats, and whether this is a subscription.
     Everything the page shows is derived from these. */
  var state = {
    pack: CFG.defaultPack || 3,
    sub: !!CFG.hasPlans          // subscription is the pre-applied default
  };

  function data(n) { return CFG.packs[String(n)] || null; }

  /* --- Pane switching ------------------------------------------------------
     Panes are stacked in one grid cell and toggled by visibility, so nothing
     below them moves. Keep the accessibility tree in step with what is seen. */
  function panes(attr, key) {
    $$('[' + attr + ']').forEach(function (el) {
      var active = el.getAttribute(attr) === key;
      el.classList.toggle('is-on', active);
      if (active) el.removeAttribute('aria-hidden');
      else el.setAttribute('aria-hidden', 'true');
      // The inactive one-time / subscribe links must not be reachable by tab.
      $$('button, a', el).forEach(function (b) { b.tabIndex = active ? 0 : -1; });
    });
  }

  /* --- Lead gallery image --------------------------------------------------
     Slide 0 follows the selection, so the picture always shows the number of
     bags being bought. Preload first: the swap then lands on an already
     decoded image instead of flashing empty. */
  var shotCache = {};
  function swapPackShot(n) {
    var shots = (window.FURRLY || {}).packShots || {};
    var s = shots[String(n)];
    var img = $('[data-packshot]');
    if (!s || !img) return;
    if (img.getAttribute('src') === s.w1000) return;

    var apply = function () {
      img.srcset = s.w400 + ' 400w, ' + s.w600 + ' 600w, ' + s.w800 + ' 800w, ' + s.w1000 + ' 1000w';
      img.src = s.w1000;
      var name = ($('.fb-head__name') || {}).textContent || 'Kind Litter';
      img.alt = name.trim() + ' — ' + n + (n === 1 ? ' bag' : ' bags');
      var th = $('[data-packshot-thumb]');
      if (th) th.src = s.thumb;
      var bar = $('[data-bb-bar-img]');
      if (bar) bar.src = s.bar || s.thumb;
    };

    if (shotCache[n]) return apply();
    var pre = new Image();
    pre.onload = pre.onerror = function () { shotCache[n] = true; apply(); };
    pre.src = s.w1000;
  }

  /* --- Render --------------------------------------------------------------
     One function, run on every change. It only ever assigns strings that came
     from the payload. */
  function render(announce) {
    if (state.pack < 1) state.pack = 1;
    if (state.pack > MAX) state.pack = MAX;

    var d = data(state.pack);
    if (!d) return;

    var now = state.sub ? d.today : d.list;
    var was = state.sub ? d.list : '';

    // Tiles. Roving tabindex: the group is one tab stop and the arrow keys
    // move within it, which is what a radiogroup is expected to do.
    // Anything past the last tile is still represented by that tile, which
    // relabels itself to the chosen count.
    var overflow = state.pack > TILES;
    tiles.forEach(function (el) {
      var n = parseInt(el.dataset.bbCat, 10);
      var isOn = n === state.pack || (overflow && n === TILES);
      el.classList.toggle('is-on', isOn);
      el.setAttribute('aria-checked', String(isOn));
      el.tabIndex = isOn ? 0 : -1;
    });
    var lbl = $('[data-bb-cat-label]');
    var lprice = $('[data-bb-cat-price]');
    if (lbl) lbl.textContent = overflow ? state.pack + ' cats' : TILES + '+ cats';
    if (lprice) lprice.textContent = (overflow ? d.list : data(TILES).list);

    // The stepper only exists once the shopper has asked for it.
    var more = $('[data-bb-more]');
    if (more) {
      var open = state.pack >= TILES;
      more.hidden = !open;
      var nEl = $('[data-bb-more-n]');
      if (nEl) nEl.textContent = state.pack + (state.pack === 1 ? ' bag' : ' bags');
      $$('[data-bb-step]').forEach(function (b) {
        var next = state.pack + parseInt(b.dataset.bbStep, 10);
        b.disabled = next < TILES || next > MAX;
      });
    }

    // Headline price. The struck price is hidden rather than emptied, so its
    // reserved slot keeps its width and the row cannot reflow.
    setText('[data-bb-now]', now);
    setPrice('[data-bb-was]', was);

    // Sentences and reassurance lines.
    panes('data-bb-pane', state.sub ? 'sub-' + state.pack : 'one');
    panes('data-bb-pane2', state.sub ? 'sub' : 'one');

    // Button, sticky bar.
    var bagsTxt = state.pack === 1 ? 'one bag' : state.pack + ' bags';
    var ctaTpl = (state.sub ? CFG.ctaSub : CFG.ctaOne) || 'Add to cart — {price}';
    setText('[data-bb-cta]', ctaTpl.replace('{bags}', bagsTxt).replace('{price}', now));
    setText('[data-bb-bar-now]', now);
    setPrice('[data-bb-bar-was]', was);

    // The form. Server-rendered to the same values, so this is a no-op on
    // first paint and the page is purchasable before JS runs at all.
    var vIn = $('[data-atc-variant]');
    var pIn = $('[data-atc-plan]');
    if (vIn) vIn.value = d.variant;
    if (pIn) pIn.value = state.sub ? CFG.planId : '';

    swapPackShot(state.pack);

    if (announce) {
      var bags = state.pack + (state.pack === 1 ? ' bag' : ' bags');
      setText('[data-bb-live]', state.sub
        ? bags + ', ' + now + ' today, then ' + d.recurring + ' ' + CFG.everyPhrase + '.'
        : bags + ', one time, ' + now + '.');
    }
  }
  function setText(sel, text) { $$(sel).forEach(function (el) { el.textContent = text; }); }

  // An empty price is hidden, never emptied: the element keeps its box, so the
  // reserved slot around it cannot collapse and pull the row in.
  function setPrice(sel, text) {
    $$(sel).forEach(function (el) {
      if (text) el.textContent = text;
      el.style.visibility = text ? '' : 'hidden';
    });
  }

  /* --- Input ---------------------------------------------------------------
     Tapping a cat tile always means "subscribe to this many bags" — that is
     what the tiles and the sentence under them describe. The one-time link is
     a separate, single-bag trial. */
  tiles.forEach(function (el) {
    on(el, 'click', function () {
      if (el.disabled) return;
      var n = parseInt(el.dataset.bbCat, 10);
      // Re-tapping the last tile when already past it drops back to its own
      // count, so there is always a way down without hunting the stepper.
      state.pack = (n === TILES && state.pack > TILES) ? TILES : n;
      render(true);
    });
  });

  // Arrow keys move the selection, as in a native radio group.
  on($('.fb-cats__grid'), 'keydown', function (e) {
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    var step = keys[e.key];
    if (!step) return;
    e.preventDefault();
    var live = tiles.filter(function (t) { return !t.disabled; });
    if (!live.length) return;
    var here = live.indexOf(document.activeElement);
    if (here < 0) here = live.indexOf($('.fb-cat.is-on'));
    var next = live[(here + step + live.length) % live.length];
    next.focus();
    next.click();
  });

  $$('[data-bb-alt]').forEach(function (b) {
    on(b, 'click', function () {
      // Switch how it is bought and keep what they chose to buy — the link
      // names that count, so changing it under them would make the link a lie.
      state.sub = b.dataset.bbAlt === 'sub';
      render(true);
      // Move focus to whichever link replaced this one. preventScroll matters:
      // the default would scroll the link into view and yank the page.
      var focus = $('[data-bb-alt]:not([tabindex="-1"])');
      if (focus) focus.focus({ preventScroll: true });
    });
  });

  $$('[data-bb-step]').forEach(function (b) {
    on(b, 'click', function () {
      if (b.disabled) return;
      state.pack += parseInt(b.dataset.bbStep, 10);
      render(true);
    });
  });

  /* --- Sticky bar ----------------------------------------------------------
     Shown whenever the real button is not on screen — which includes the first
     paint, since on a phone the gallery pushes the button just below the fold.
     The previous rule only fired after scrolling past it, which left the top of
     the page with no visible way to buy. */
  var bar = $('[data-bb-bar]');
  var anchor = $('[data-cta-anchor]');
  if (bar && anchor) {
    var ticking = false;
    var sync = function () {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      var onScreen = r.bottom > 10 && r.top < h - 10;
      bar.classList.toggle('is-on', !onScreen);
    };
    var queue = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    };
    on(window, 'scroll', queue, { passive: true });
    on(window, 'resize', queue);
    sync();
  }

  /* --- Sticky bar button ---------------------------------------------------
     Routed through the form so furrly.js's single add-to-cart handler runs.
     Without furrly.js the dispatch goes unprevented and the form posts to
     /cart/add the ordinary way, which still works. */
  var mainBtn = $('[data-atc-btn]', form);
  $$('[data-bb-bar-cta]').forEach(function (b) {
    on(b, 'click', function () {
      if (!form) return;
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
      var ev = new Event('submit', { bubbles: true, cancelable: true });
      if (form.dispatchEvent(ev)) form.submit();
    });

    // furrly.js disables the main button for the duration of the request;
    // mirror that here so the bar button reports the same state.
    if (mainBtn && window.MutationObserver) {
      new MutationObserver(function () { b.disabled = mainBtn.disabled; })
        .observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
  });

  /* --- Title on one line ---------------------------------------------------
     Product names vary, so this measures rather than assumes: shrink from the
     CSS size until it fits the column. Below the floor it is allowed to wrap
     again — a two-line name beats a name too small for this audience to read. */
  (function fitTitle() {
    var el = $('.fb-head__name');
    if (!el) return;
    var MIN = 24;
    function fit() {
      el.style.whiteSpace = 'nowrap';
      el.style.fontSize = '';
      var size = parseFloat(getComputedStyle(el).fontSize);
      while (size > MIN && el.scrollWidth > el.clientWidth) {
        size -= 1;
        el.style.fontSize = size + 'px';
      }
      if (el.scrollWidth > el.clientWidth) {
        el.style.whiteSpace = '';
        el.style.fontSize = '';
      }
    }
    fit();
    on(window, 'resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  })();

  render(false);
})();
